import React from 'react'

export default function CounterFrame(props: {value: number, withPlus?: boolean, title: string}) {
  return (
    <div className="art-counter-frame">
      {/* counter */}
      <div className="art-counter-box">
        {/* counter number */}
        <span className="art-counter">{props.value}</span>
        {props.withPlus && <span className="art-counter-plus">+</span>}
      </div>
      {/* counter end */}
      {/* title */}
      <h6>{props.title}</h6>
    </div>
  )
}
